import { html } from '@design.estate/dees-element';
import { demoPage } from '../../../demos/templates.js';
import type { IHarnessSessionGroup, IHarnessSessionMeta, IHarnessResourceMeta } from '../interfaces.js';

const demoSessions: IHarnessSessionMeta[] = [
  { id: 's1', title: 'Fix sitemap cache key', projectLabel: 'storefront', updatedAt: Date.now() - 1_000 },
  { id: 's2', title: 'Investigate model rate limits', projectLabel: 'gateway', updatedAt: Date.now() - 2_000 },
  { id: 's3', title: 'Prepare the catalog release', projectLabel: 'catalog', updatedAt: Date.now() - 3_000 },
  { id: 's4', title: 'Improve agent onboarding', updatedAt: Date.now() - 4_000 },
];

const demoResources: IHarnessResourceMeta[] = [
  { id: 'terminal:build', kind: 'terminal', title: 'Build shell', icon: 'lucide:Terminal', projectLabel: 'storefront' },
];

const demoGroups: IHarnessSessionGroup[] = [
  { id: 'active', name: 'Workspace', itemIds: [{ kind: 'session', id: 's1' }, { kind: 'session', id: 's2' }] },
  { id: 'review', name: 'Review', itemIds: [{ kind: 'session', id: 's3' }] },
];

export const demoFunc = () => demoPage(
  'Conversation picker',
  'Keyboard-first target picker: type to filter on title, project label or group, Enter picks, Escape cancels.',
  html`
    <style>
      .pickerDemo {
        max-width: 420px;
        padding: 16px;
        border: 1px solid var(--dees-color-border-subtle);
        border-radius: var(--dees-radius-xl);
        background: var(--dees-color-bg-secondary);
      }
    </style>
    <div class="pickerDemo">
      <dees-harness-conversation-picker
        heading="Attach Build shell to…"
        .sessions=${demoSessions}
        .groups=${demoGroups}
        .resources=${demoResources}
        .excludeTargets=${[{ kind: 'session' as const, id: 's4' }]}
        @harness-picker-choose=${(event: CustomEvent) => console.log('picked', event.detail.target)}
        @harness-picker-cancel=${() => console.log('cancelled')}
      ></dees-harness-conversation-picker>
    </div>
  `,
);
